import { FC, useCallback } from "react";
import { Portal } from "src/atoms/Portal";
import { useFeatureFlags } from "src/hooks/useFeatureFlags";
import { useLockBodyScroll } from "src/hooks/useLockBodyScroll";
import { useGuestLookupIntent } from "src/hooks/stores/use-header-store";
import { headerStore } from "src/stores/header/header.store";
import { GuestOrderLookup } from "./GuestOrderLookup";
import { SheetOverlay, SheetWrapper } from "./GuestOrderLookup.styled";

const GuestOrderLookupSheet: FC = () => {
  const intent = useGuestLookupIntent();
  const { showGuestReturnForm } = useFeatureFlags();
  const handleClose = useCallback(() => headerStore.closeGuestLookup(), []);
  useLockBodyScroll(Boolean(intent && showGuestReturnForm));

  if (!intent || !showGuestReturnForm) {
    return null;
  }

  return (
    <Portal selector="#portal">
      <SheetOverlay data-testid="guest-lookup-overlay" onClick={handleClose} />
      <SheetWrapper role="dialog" aria-modal="true">
        <GuestOrderLookup intent={intent} onBack={handleClose} />
      </SheetWrapper>
    </Portal>
  );
};

export { GuestOrderLookupSheet };
